$(function() {
      $('#billing_cnpj').mask('00.000.000/0000-00');
      $('#billing_postcode').mask('00000-000');
      $('.input-cep').mask('00000-000');
      $('#billing_phone').mask('(00) 0000-0000');
      $('#billing_cellphone').mask('(00) 00000-0000');
      $('.your-tel .field').mask('(00) 0000-0000');
      $('.your-cel .field').mask('(00) 00000-0000');
});